// extracted by mini-css-extract-plugin
export default {"auctionCardContainer":"AuctionCardDetails_auctionCardContainer__258SE"};